<div class="agg-card" [style.border-top-color]="cardColor()" (click)="data().uri && openUri(data().uri)">
    <img class="agg-card__icon" [src]="image()" [attr.alt]="data()! | translateToken: 'label'" />

    <div class="agg-card__body">
        <span class="agg-card__value" [style.color]="cardColor()">
            @if (hasWeightsProblem()?.value) {
                <i class="fa fa-warning" [title]="hasWeightsProblem()?.message ?? '' | translate"></i>
            } @else if (isDefined(amount()) && amount() > 0) {
                <adaa-count-up [total]="amount()" />
            } @else {
                {{ amount() | percentageValue }}
            }
        </span>

        <span class="agg-card__label">{{ data()! | translateToken: "label" }}</span>
    </div>

    <span class="agg-card__bar">
        <span [style.width.%]="progress()" [style.background-color]="cardColor()"></span>
    </span>

    <div class="agg-card__actions d-flex justify-content-between align-items-center">
        <div class="agg-card__action-group d-flex">
            @if (hideKpiListButton(data().id) && data().showChildItems) {
                <button class="agg-card__btn" [title]="'breadcrumbs.kpi' | translate" (click)="buttonClicked($event, 'kpi')">
                    <i class="adaa-icon-console_kpis"></i>
                </button>
            }
            @if (AdaaHelper.isPMOEntity()) {
                <button
                    class="agg-card__btn"
                    [title]="'common.form.label.performance_comparison' | translate"
                    (click)="buttonClicked($event, 'graph')"
                >
                    <fa-icon [icon]="graphIcon" />
                </button>
            }
        </div>

        @if (children().length) {
            <button
                class="agg-card__more"
                [title]="'dimension.show_more' | translate"
                [dir]="languageService.direction()"
                (click)="$event.stopPropagation(); showMore.set(!showMore())"
            >
                @if (!showMore()) {
                    <span class="agg-card__more-count">{{ children().length }}</span>
                    <fa-icon [icon]="moreIcon[languageService.direction()]" />
                } @else {
                    <fa-icon [icon]="moreIcon[languageService.direction() === 'rtl' ? 'ltr' : 'rtl']" />
                }
            </button>
        }
    </div>
</div>

<adaa-scores-by-aggregation-type
    [periodId]="period()?.period?.id"
    [year]="period()?.period?.year"
    [periodType]="period()?.type!"
    [propId]="data().id"
    [isProjectScore]="isProjectScore(data().id)"
    #scoresByAggregationType
/>

@if (showMore()) {
    <div class="agg-card__children d-flex" [class.flex-column]="isColumnLayout()">
        @for (childData of children(); track childData.id) {
            <div class="agg-card__child" [style.border-inline-start-color]="getChildColor(childData)">
                <span class="agg-card__child-value" [style.color]="getChildColor(childData)">
                    @if (hasWeightsProblem()?.value) {
                        <i class="adaa-icon-warning"></i>
                    } @else if (isDefined(childData.value) && childData.value > 0) {
                        <adaa-count-up [total]="childData.value" />
                    } @else {
                        {{ childData.value | percentageValue }}
                    }
                </span>

                <span class="agg-card__child-label">{{ childData | translateToken: "label" }}</span>

                <div class="agg-card__actions agg-card__action-group d-flex">
                    @if (hideKpiListButton(childData.id) && data().showChildItems) {
                        <button class="agg-card__btn" [title]="'breadcrumbs.kpi' | translate" (click)="childScoresByAggregationType.open()">
                            <i class="adaa-icon-console_kpis"></i>
                        </button>
                    }
                    @if (AdaaHelper.isPMOEntity()) {
                        <button
                            class="agg-card__btn"
                            [title]="'common.form.label.performance_comparison' | translate"
                            (click)="performanceGraphClicked.emit(childData)"
                        >
                            <fa-icon [icon]="graphIcon" />
                        </button>
                    }
                </div>
            </div>

            <adaa-scores-by-aggregation-type
                [periodId]="period()?.period?.id"
                [year]="period()?.period?.year"
                [periodType]="period()?.type!"
                [propId]="childData.id"
                [isProjectScore]="isProjectScore(childData.id)"
                #childScoresByAggregationType
            />
        }
    </div>
}
